import { CardSlider } from './card-slider';
import { formatUrl }  from './payment-utils';
import { i18n }       from '@/commons/utils';

const PS = {};

const setVars = () => {
  PS.usedAmount          = 0;
  PS.amount              = '';
  PS.isOpen              = false;
  PS.block               = cube.$id('secondary-payment-block');
  PS.container           = PS.block.$('.dkt-card-slider-container');
  PS.message             = PS.block.$('.dkt-block-message');
  PS.messageText         = PS.block.$('.dkt-block-message-text');
  PS.numberOfMoP         = PS.block.$$('.dkt-card[data-payment-group-id]').length;
  PS.numberOfSelectedMoP = 0;
  PS.noBtn               = PS.block.$id('secondary-payment-no');
  PS.yesBtn              = PS.block.$id('secondary-payment-yes');
  PS.form                = PS.block.$('form[data-role="gift-card-form"]');
  PS.orderAmount         = parseInt(cube.$id('pay-order-btn').dataset.amount, 10);
  PS.slider              = null;
  PS.captchaElt          = null;
  PS.debounce            = null;
  PS.isActiveByDefault   = true;
};


const initCaptcha = () => {
  PS.captchaElt = cube.$id('secondary-mop-captcha');

  const setCaptcha = () => {
    if (PS.captchaElt && PS.captchaElt.dataset.required === 'true') {
      window.decathlon.captcha.captchaRequired = true;
      PS.captchaElt.style.display = 'block';
    }
  };

  let captchaTimer;

  const checkForCaptcha = () => {
    clearTimeout(captchaTimer);
    captchaTimer = setTimeout(() => {
      if (window.decathlon.captcha) setCaptcha();
      else checkForCaptcha();
    }, 100);
  };

  checkForCaptcha();

  window.setCaptchaChecked = resp => {
    window.decathlon.captcha.responseToken = resp;
    window.decathlon.captcha.isCaptchaChecked = true;
    PS.captchaElt.style.display = 'none';
    hideMessage();
  };

  window.setCaptchaUnchecked = () => {
    window.decathlon.captcha.isCaptchaChecked = false;
  };
};



const showCaptcha = () => {
  if (PS.captchaElt) {
    PS.captchaElt.style.display = 'block';
    window.decathlon.captcha.captchaRequired = true;
    window.decathlon.captcha.resetCaptcha();
  }
};

const hideCaptcha = () => {
  if (PS.captchaElt) {
    PS.captchaElt.style.display = 'none';
    window.decathlon.captcha.captchaRequired = false;
  }
};


const activateSecondaryBlock = isMultiEnabled => {
  PS.block.classList.toggle('dkt-block--disabled', !isMultiEnabled);

  if (!isMultiEnabled) closeBlock();
  else if (PS.isOpen && PS.block.$('.dkt-card-slider-item--selected')) openBlock();

  PS.yesBtn.disabled = !isMultiEnabled;
  PS.noBtn.disabled  = !isMultiEnabled;
};


const openBlock = () => {
  if (!PS.block.classList.contains('dkt-block--disabled')) {
    PS.yesBtn.checked = true;
    PS.noBtn.checked = false;

    PS.block.$$('.dkt-card-slider-item--deleted').forEach(item => item.remove());

    // TODO: remove jQuery for slideDown (use CSS class ?)
    $(PS.block.$('.dkt-block-content')).slideDown(() => {
      PS.block.classList.add('dkt-block--open');
      PS.isOpen = true;

      document.dispatchEvent(new CustomEvent('SecondaryPaymentChanged', {
        detail: { amount: PS.usedAmount }
      }));

      PS.numberOfSelectedMoP = PS.block.$$('.dkt-card-slider-item--selected').length;

      updateDisplay();
      updateUsedAmount();

      if (PS.slider) PS.slider.goToItem(0);
    });
  }
};


const closeBlock = () => {
  PS.yesBtn.checked = false;
  PS.noBtn.checked = true;

  // TODO: remove jQuery for slideUp (use CSS class ?)
  $(PS.block.$('.dkt-block-content')).slideUp(() => {
    PS.block.classList.remove('dkt-block--open');
    PS.isOpen = false;

    document.dispatchEvent(new CustomEvent('SecondaryPaymentChanged', {
      detail: { amount: 0.00 }
    }));

    updateDisplay();

    if (PS.slider) PS.slider.goToItem(0);
  });
};


const updateDisplay = () => {
  PS.block.classList.toggle('dkt-block--selected', (PS.isOpen && PS.numberOfSelectedMoP > 0));

  cube.$('[data-role=number-of-secondary-mop]').innerHTML = PS.numberOfMoP;
  cube.$('[data-role=number-of-selected-secondary-mop]').innerHTML = PS.numberOfSelectedMoP;
};


const updateUsedAmount = () => {
  let usedAmount = 0;

  cube.$$('.dkt-gift-card').forEach(card => {
    if (card.dataset.isSelected === 'true') {
      usedAmount += Number(card.dataset.amount);
    }
  });

  PS.usedAmount = usedAmount;

  cube.$$('[data-role=gift-card-amount-used]').forEach(totalAmount => {
    totalAmount.innerHTML = cube.priceFormatter(usedAmount);
    totalAmount.setAttribute('data-amount', usedAmount);
  });

  document.dispatchEvent(new CustomEvent('SecondaryPaymentChanged', {
    detail: { amount: usedAmount }
  }));
};


const hideMessage = () => {
  PS.message.classList.remove('dkt-block-message--visible');
  PS.messageText.innerHTML = '';
};


const displayMessage = message => {
  PS.message.classList.add('dkt-block-message--visible');
  PS.messageText.innerHTML = message;

  setTimeout(hideMessage, 10000);
};


const updateAmounts = () => {
  const debitedAmounts = PS.block.$$('.amount-debited');

  const totalSecondaryAmount = evaluateTotalSecondaryAmount(debitedAmounts);
  const amountDisplayed = cube.priceFormatter(totalSecondaryAmount);

  if (cube.$id('total-amount-used')) {
    cube.$id('total-amount-used').innerHTML = amountDisplayed;
  }

  PS.block.classList.toggle('selected', (totalSecondaryAmount === '0.00'));

  const paymentNumber = evaluateNumberSecondary(debitedAmounts);

  if (PS.block.$('.payment-number')) PS.block.$('.payment-number').innerHTML = paymentNumber;

  document.dispatchEvent(new CustomEvent('SecondaryPaymentChanged', {
    detail: { amount: totalSecondaryAmount }
  }));
};


const evaluateTotalSecondaryAmount = debitedAmounts => {
  let totalSecondaryAmount = 0;

  debitedAmounts.forEach(amount => {
    let currentAmount = parseFloat(amount.value);
    if (Number.isNaN(currentAmount)) currentAmount = 0;
    totalSecondaryAmount += currentAmount;
  });

  return Number(totalSecondaryAmount).toFixed(2);
};


const evaluateNumberSecondary = debitedAmounts => {
  let numberSecondary = 0;

  debitedAmounts.forEach(amount => {
    if (amount.dataset.paymentGroupId !== 'template') numberSecondary += 1;
  });

  return Number(numberSecondary);
};


const selectSecondaryPayment = () => {
  if (PS.yesBtn.checked) openBlock();
  if (PS.noBtn.checked)  closeBlock();
};


const addSecondaryPayment = event => {
  event.preventDefault();

  const numberField    = PS.form.$id('gift-card-number-field');
  const pinCodeField   = PS.form.$id('gift-card-pincode-field');
  const number         = numberField.$id('tb-gift-card-number').value.replace(/\D/g, '');
  const pincode        = pinCodeField.$id('tb-gift-card-pincode').value;
  const numberLengthOk = number.length  === 16 || (cube.config.feature_illicadoGiftcard === 'true' && number.length === 19);
  const pinLengthOk    = pincode.length === 4  || (cube.config.feature_illicadoGiftcard === 'true' && pincode.length === 3);

  numberField.classList.toggle('dkt-card-field--error', !numberLengthOk);
  pinCodeField.classList.toggle('dkt-card-field--error', !pinLengthOk);

  if (numberLengthOk && pinLengthOk) {
    window.decathlon.tools.displayLoader(true, false, PS.form);

    const params = {
      cardNumber: number,
      pinCode: pincode,
      paymentTypeId: '11'
    };

    if (window.decathlon && window.decathlon.captcha && window.decathlon.captcha.captchaRequired) {
      params[window.decathlon.captcha.responseTag] = window.decathlon.captcha.responseToken;
    }

    cube.ajax.post(formatUrl('doCheckGift'), params)
      .onSuccess(onAddGiftCardSuccess)
      .onError(onRequestError)
      .call()
    ;

    clearForm();
  }
};


const clearForm = () => {
  PS.form.$$('.dkt-card-field[id]').forEach(field => {
    field.$('input').value = '';
    field.classList.remove('dkt-card-field--error');
  });
};


const closeForm = () => {
  clearForm();
  window.decathlon.tools.displayLoader(false, false);
};

const checkEnteredAmount = event => {
  const input     = event.target;
  const amount    = input.value.toString();
  const digits    = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 37, 39, 8];  // [0-9]
  /* 37: Arrow Left, 39: Arrow Right, 8: Backspace are added for NRT ¯_(ツ)_/¯ */
  const separator = [44, 46];                                             // [, .]
  const key = event.keyCode || event.which;

  if (
    // Max 7 characters (xxxx.xx)
    (amount.length === 7) ||

    // max one separator
    (separator.includes(key) && (amount.includes(',') || amount.includes('.'))) ||

    // Authorize only digits, comma ant dot
    (!digits.includes(key) && !separator.includes(key)) ||

    // For HK, even commas and dots are forbidden (only round prices)
    (cube.env.country === 'HK' && separator.includes(key))
  ) {
    event.preventDefault();
  }

  else {
    window.clearTimeout(PS.debounce);
    PS.debounce = window.setTimeout(() => validEnteredAmount(event), 1000);
  }
};



const validEnteredAmount = event => {
  PS.debounce = null;

  const input          = event.target;
  const pattern        = /^\d{1,4}([.,]\d{1,2})?$/; // 0000.00 or 0000,00
  const min            = parseFloat(input.min);
  const max            = parseFloat(input.max);
  const card           = input.closest('.dkt-card');
  const paymentGroupId = card.getAttribute('data-payment-group-id');

  let amount = parseFloat(input.value.replace(/,/g, '.'));

  amount = Math.max(amount, min);
  amount = Math.min(amount, max);

  const formatedAmount = amount.toFixed(2);

  if (pattern.test(formatedAmount)) {
    input.value = formatedAmount;

    if (pattern.test(formatedAmount)) {
      input.value = formatedAmount;
      updateGiftAmount(paymentGroupId, parseFloat(formatedAmount));
    }

    else input.value = '0.0';
  }
};



const updateGiftAmount = (paymentGroupId, amount) => {
  cube.$$('.dkt-checkout-primary-button').forEach(button => {
    button.disabled = true;
    button.classList.add('disabled');
  });

  cube.ajax.post(formatUrl('updateGiftAmount'), {paymentGroupId, amount})
    .onSuccess(onUpdateGiftAmountSuccess)
    .onError(onUpdateGiftAmountError)
    .call()
  ;
};



const onUpdateGiftAmountSuccess = response => {
  cube.$$('.dkt-checkout-primary-button').forEach(button => {
    button.disabled = false;
    button.classList.remove('disabled');
  });

  let card;

  if (response.error) cube.alert.error(response.error.message);

  else if (response.responseTO) {
    if (response.responseTO.data === false) {
      displayMessage(response.responseTO.errors[0].message);

      card = PS.block.$('.dkt-card-slider-item--selected .dkt-card');
      card.$('[data-role=gift-card-used-amount]').value = 0.00;
      card.setAttribute('data-amount', 0.00);

      updateUsedAmount();
    }
  }

  else if (response.result.data !== false) {
    if (response.result.data.warning) displayMessage(i18n(response.result.data.warning));

    if (response.result.data.messages) displayMessage(i18n(response.result.data.messages[0]));
    else {
      const { data } = response.result;
      card = cube.$(`.dkt-card[data-payment-group-id=${data.paymentGroupId}]`);
      card.$('[data-role=gift-card-used-amount]').value = data.giftUsedAmount.toFixed(2);
      card.setAttribute('data-amount', data.giftUsedAmount);

      card.closest('.dkt-card-slider-item').classList.toggle('dkt-card-slider-item--empty', data.giftUsedAmount === 0);

      updateUsedAmount();

      if (response.result.messages && response.result.messages.length > 0) {
        card.$('.dkt-gift-card-to-use').classList.toggle('dkt-gift-card-to-use--highlighted', data.giftUsedAmount !== 0);
        displayMessage(i18n(response.result.messages[0].code));
      }
    }
  }

  else displayMessage(response.responseTO.errors[0].message);
};


const onUpdateGiftAmountError = () => {
  cube.$$('.dkt-checkout-primary-button').forEach(button => {
    button.disabled = false;
    button.classList.remove('disabled');
  });

  window.decathlon.tools.displayLoader(false, false);
  cube.alert.error(i18n('error.oc.call'));
};


const selectCard = event => {
  event.preventDefault();

  hideMessage();
  const card = event.target.closest('.dkt-card');

  if (!card.classList.contains('dkt-gift-card--disabled')) {
    window.decathlon.tools.displayLoader(true, true, card);
    card.setAttribute('data-is-loading', 'true');

    const paymentGroupId = card.getAttribute('data-payment-group-id');
    const tokenId = card.getAttribute('data-token-id');

    cube.ajax.post(formatUrl('doReuseGift'), { paymentGroupId : paymentGroupId || tokenId })
      .onSuccess(response => onReuseCardSuccess(card, response))
      .onError(onRequestError)
      .call()
    ;
  }
};


const onReuseCardSuccess = (card, response) => {
  window.decathlon.tools.displayLoader(false, false);

  if (response.error) cube.alert.error(response.error.message);

  else if (response.responseTO) {
    if (response.responseTO.data === false) {
      if (response.responseTO.errors[0].code === 'PAY_0050') {
        card.classList.add('dkt-gift-card--disabled');
        card.$('.dkt-gift-card-message').innerHTML = response.responseTO.errors[0].message;
      }
      else {
        displayMessage(response.responseTO.errors[0].message);
      }
    }
  }

  else if (response.result.data !== false) {
    if (response.result.data.warning && (response.result.data.warning === 'PAY_0060' || response.result.data.warning === 'PAY_0050')) {
      card.$('.dkt-gift-card-message').innerHTML = i18n(response.result.data.warning);
      displayMessage(i18n(response.result.data.warning));
      const index = card.closest('.dkt-card-slider-item').dataset.index;
      PS.slider.deleteItem(index);
    }

    else {
      const { data } = response.result;

      card.closest('.dkt-card-slider-item').classList.add('dkt-card-slider-item--selected');

      if (data.giftUsedAmount === 0) {
        card.closest('.dkt-card-slider-item').classList.add('dkt-card-slider-item--null');
      }

      card.$('.dkt-gift-card-amount').innerHTML = cube.priceFormatter(data.giftCardBalance);
      card.$('input[data-role="gift-card-used-amount"]').removeAttribute('disabled');
      card.$('input[data-role="gift-card-used-amount"]').value = data.giftUsedAmount;
      card.$('input[data-role="gift-card-used-amount"]').max = data.giftCardBalance;

      card.setAttribute('data-is-selected', 'true');
      card.setAttribute('data-balance', data.giftCardBalance);
      card.setAttribute('data-amount', data.giftUsedAmount);
      card.setAttribute('data-payment-group-id', data.paymentGroupId);

      PS.numberOfSelectedMoP += 1;
      updateUsedAmount();
      updateDisplay();
    }
  }

  else displayMessage(response.responseTO.errors[0].message);

  card.removeAttribute('data-is-loading');
};



const deleteCard = event => {
  if (event.target.tagName !== 'INPUT') {
    cube.$$('.dkt-card--deleting').forEach(card => card.classList.remove('dkt-card--deleting'));
    event.target.closest('.dkt-card').classList.add('dkt-card--deleting');
  }
};


const deleteCardCancelation = event => {
  event.target.closest('.dkt-card').classList.remove('dkt-card--deleting');
};


const deleteCardValidation = event => {
  const card = event.target.closest('.dkt-card');
  const paymentGroupId = card.getAttribute('data-payment-group-id');

  window.decathlon.tools.displayLoader(true, true, card);

  cube.ajax.post(formatUrl('removeGift'), { paymentGroupId })
    .onSuccess(onRemoveCardSuccess)
    .onError(onRequestError)
    .call()
  ;
};


const onRemoveCardSuccess = response => {
  window.decathlon.tools.displayLoader(false, false);

  if (response.error) cube.alert.error(response.error.message);

  else if (response.responseTO) {
    if (response.responseTO.data === false) {
      displayMessage(response.responseTO.errors[0].message);
    }
  }

  else if (response.result.data !== false) {
    if (response.result.data.warning)  displayMessage(i18n(response.result.data.warning));
    if (response.result.data.messages) displayMessage(i18n(response.result.data.messages[0]));
    else {
      const { data } = response.result;
      const card = cube.$(`.dkt-card[data-payment-group-id=${data.paymentGroupId}]`);

      card.closest('.dkt-card-slider-item').classList.remove('dkt-card-slider-item--selected');
      card.setAttribute('data-is-selected', false);
      card.setAttribute('data-amount', 0.00);

      PS.numberOfSelectedMoP -= 1;
      PS.numberOfMoP -= 1;

      updateUsedAmount();
      updateDisplay();

      const index = card.closest('.dkt-card-slider-item').dataset.index;
      PS.slider.deleteItem(index);
    }
  }

  else {
    displayMessage(response.responseTO.errors[0].message);
  }
};


const onRequestError = () => {
  cube.alert.error(i18n('error.oc.call'));
};


const onAddGiftCardSuccess = response => {
  window.decathlon.tools.displayLoader(false, false);

  if (response.error) cube.alert.error(response.error.message);

  else if (response.responseTO) {
    if (!response.responseTO.data) {
      const firstError = response.responseTO.errors[0];
      displayMessage(firstError.message);

      if (firstError && firstError.code === 'captcha.error.invalid' || (response.responseTO.errors.length > 1 && response.responseTO.errors[1].code === 'PAY_0082'))
        showCaptcha();
      else
        hideCaptcha();
    }
  }

  else if (response.result.data !== false) {
    if (response.result.data.warning) displayMessage(i18n(response.result.data.warning));
    else {
      const card = {};
      const { data } = response.result;

      if (data.oldPaymentGroupToRemove !== null) {
        const cardToRemove = cube.$(`div[data-payment-group-id="${data.oldPaymentGroupToRemove}"]`) || $(`div[data-token-id=${data.oldPaymentGroupToRemove}]`);
        const cardToRemoveIndex = cardToRemove.closest('li').dataset.index;
        PS.slider.deleteItem(cardToRemoveIndex);
      }

      card.balance        = data.giftCardBalance;
      card.paymentGroupId = data.paymentGroupId;
      card.number         = data.card;
      card.giftUsedAmount = data.giftUsedAmount;
      card.voucher        = data.voucher;
      card.name           = i18n(`payment.name.${data.paymentName}`);

      PS.numberOfMoP += 1;
      PS.numberOfSelectedMoP += 1;

      const state = getSliderState(PS.container);

      state.numberOfItems += 1;

      const isVoucherClass = card.voucher ? 'dkt-gift-card--voucher' : '';
      const isEmptyClass   = card.giftUsedAmount === 0 ? 'dkt-card-slider-item--empty' : null;
      const balance        = cube.priceFormatter(card.balance);
      const symbol         = window.priceFormatterInfos ? window.priceFormatterInfos.currency.symbol : '';

      const newCardTemplate = document.createElement('li');
      newCardTemplate.classList.add('dkt-card-slider-item', 'dkt-card-slider-item--new', 'dkt-card-slider-item--hideCard');
      if (isEmptyClass)  newCardTemplate.classList.add(isEmptyClass);

      if (PS.isActiveByDefault) newCardTemplate.classList.add('dkt-card-slider-item--selected');

      newCardTemplate.style.transform = `translateX('-${state.currentItemIndex * 280}px')`;

      newCardTemplate.innerHTML = `
        <div class="dkt-card dkt-gift-card ${isVoucherClass}" data-is-selected="${PS.isActiveByDefault}" data-amount="${card.giftUsedAmount}" data-tnr-secondary-token="${card.paymentGroupId}" data-payment-group-id="${card.paymentGroupId}" data-balance="${card.balance}">
          <img class="dkt-card-logo" src="/assets/images/decathlon-logo.svg" alt="Decathlon" data-tnr-secondary-token-logo>
          <span class="dkt-card-code" data-tnr-secondary-token-code>${card.number}</span>
          <div class="dkt-gift-card-content">
            <span class="dkt-card-title">${card.name}</span>
            <div class="dkt-gift-card-balance">
                <span class="dkt-gift-card-label">${i18n('payment.secondary.balance')}</span>
                <span class="dkt-gift-card-amount">${balance}</span>
              </div>
              <div class="dkt-gift-card-to-use">
                <label class="dkt-gift-card-label">${i18n('payment.secondary.amountToUse')}</label>
                <input data-role="gift-card-used-amount" min="0" max="${card.balance}" type="text" value="${card.giftUsedAmount}" data-tnr-secondary-token-amount>
              <span class="dkt-gift-card-to-use-currency">${symbol}</span>
              </div>
            </div>
            <button class="dkt-card-button" data-role="use-gift-card"><span>${i18n('payment.secondary.useThisCard')}</span></button>
            <div class="dkt-gift-card-delete">
              <div class="dkt-gift-card-delete-content">
                <p>${i18n('payment.secondary.deleteConfirmation')}</p>
                <button data-role="delete-cancel" class="cta small left grey">${i18n('payment.secondary.deleteNo')}</button>
                <button data-role="delete-validate" class="cta small right grey">${i18n('payment.secondary.deleteYes')}</button>
              </div>
          </div>
        </div>
      `;


      PS.slider.addItem(newCardTemplate);

      updateDisplay();
      updateUsedAmount();

      if (window.cube.config.anly_useLegacy === 'Y') {
        CUBE.Analytics.newEvent(null, 'CheckoutEvent', 'Checkout - Payment', 'SelectGiftPaymentMethod', card.name.toUpperCase(), '', false).send();
      }
    }

    hideCaptcha();
  }

  else displayMessage(response.responseTO.errors[0].message);
};


const getSliderState = slider => {
  const state = {
    currentItemIndex      : parseInt(slider.getAttribute('data-current-item-index'), 10),
    numberOfItems         : parseInt(slider.getAttribute('data-number-of-items'), 10),
    numberOfVisiblesItems : parseInt(slider.getAttribute('data-number-of-visibles-items'), 10),
    widthOfItem           : parseInt(slider.getAttribute('data-width-of-item'), 10)
  };
  return state;
};


const initHandlers = () => {
  // When user fill new card form and submit it
  if (PS.form)
    PS.form.on('submit', addSecondaryPayment);

  // When user click on form close button, we clear form and remove loader
  if (PS.form.$('.dkt-button-close'))
    PS.form.$('.dkt-button-close').on('click', closeForm);

  // When user focus on a form input, we remove errors
  PS.form.$$('input[id]').forEach(input => {
    if (input) input.on('focus', () => input.closest('.dkt-card-field').classList.remove('dkt-card-field--error'));
  });

  // When user enters an amount in the gift card input
  PS.block.delegate('keypress', 'input[data-role="gift-card-used-amount"]', checkEnteredAmount);
  PS.block.delegate('focusout', 'input[data-role="gift-card-used-amount"]', validEnteredAmount);

  // User navigate between used card with tab key
  PS.block.delegate('focus', 'input[data-role="gift-card-used-amount"]', event => {
    event.preventDefault();
    event.target.select();
    PS.slider.displayFocusedCard(event.target);
  });
  PS.block.delegate('focus', '[data-role="secondary-payment-block"] .dkt-flipable button:not(.dkt-button-close)', event => {
    event.preventDefault();
    PS.slider.displayFocusedCard(event.target);
  });

  // User select a card (if not active by default)
  PS.block.delegate('click', '[data-role="use-gift-card"]', selectCard);

  // User click on an active card to remove it, we display confirmation panel
  PS.block.delegate('click', '.dkt-card[data-is-selected="true"]:not(.dkt-card--deleting)', deleteCard);

  // User cancel card deletion, we hide confirmation panel
  PS.block.delegate('click', '[data-role="delete-cancel"]', deleteCardCancelation);

  // User confirm card deletion, delete it
  PS.block.delegate('click', '[data-role="delete-validate"]', deleteCardValidation);

  // Select or deselect Secondary payment
  selectSecondaryPayment();
  PS.noBtn.on('change', selectSecondaryPayment);
  PS.yesBtn.on('change', selectSecondaryPayment);
};



export const initCheckout = () => {
  setVars();
  initCaptcha();

  document.addEventListener('PrimaryPaymentBlockSelected', event => {
    const isMultiEnabled = event.detail.multiEnabled && (event.detail.multiEnabled === 'true' || event.detail.multiEnabled === true);
    activateSecondaryBlock(isMultiEnabled);
  });

  const giftcardOpenByDefault = cube.config.feature_openGiftCardBlockByDefault && cube.config.feature_openGiftCardBlockByDefault === 'true';
  const hasSelectedGiftcards  = PS.block.$$('.dkt-card-slider-item--selected').length > 0;
  const hasSavedGiftCard      = PS.block && PS.block.dataset.hasSavedGiftCard === 'true';

  if (hasSelectedGiftcards || (hasSavedGiftCard && giftcardOpenByDefault)) {
    openBlock();
  }
  else {
    closeBlock();
  }

  PS.slider = new CardSlider();
  PS.slider.init({
    container     : PS.container,
    parent        : PS.block,
    displayNewCard: true,
  });

  updateDisplay();
  updateAmounts();
  initHandlers();
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-secondary.js